import { render, staticRenderFns } from "./EntityProfileHeader.vue?vue&type=template&id=56910267"
import script from "./EntityProfileHeader.vue?vue&type=script&lang=js"
export * from "./EntityProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports